import { ApiError } from "../api";
import type { LoginResponse } from "@saquei/types";

/**
 * POST /api/v1/auth/login. Retorna o discriminated union do backend.
 * Lanca ApiError em qualquer status != 2xx (rede, 401, 400, etc).
 */
export async function login(email: string, password: string): Promise<LoginResponse> {
    const resp = await fetch("/api/v1/auth/login", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email, password }),
    });
    if (!resp.ok) {
        let msg = `HTTP ${resp.status}`;
        try {
            const body = await resp.json();
            if (body?.error?.message) msg = String(body.error.message);
        } catch {
            // ignore
        }
        throw new ApiError(resp.status, msg);
    }
    return (await resp.json()) as LoginResponse;
}
